import FormDocument, { FormRenderConfig } from ".";

declare global {
  interface Window {
    renderFormWithConfig: (config: FormRenderConfig) => void;
  }
}

export default () => {
  window.renderFormWithConfig = (config: FormRenderConfig) => {
    const formDocument = new FormDocument(config);
    formDocument.renderAsBody();

    return true;
  };

  return <span id="pdf-call-render">CALL_RENDER</span>;
};
